export const API_URL = process.env.VUE_APP_API_URL + 'api/'
export const VERSION = 'v1'
export const BASE_URL = process.env.VUE_APP_API_URL
const CLIENT_SECRET = process.env.VUE_APP_API_SECRET
export const BASE_TOKEN = process.env.VUE_APP_API_URL ;

export default {
    oauth: {
        grant_type: 'password',
        client_id: 1,
        client_secret: CLIENT_SECRET,
        scope: '*'
    },
    // Supported Types 'Cookies', 'sessionStorage'
    default_storage: 'Cookies',
    oauth_type: 'Bearer'
}
